import { inject, Injectable, Injector } from '@angular/core';

import {
  DataManagerController,
  DataManagerTipoController,
} from '../application/data-manager-controller';
import { DataManagerProvider } from '../contracts/data-manager-provider';

@Injectable({ providedIn: 'root' })
export class DataManagerService {
  // Injectables
  private injector = inject(Injector);

  // Private
  private dataManagerControllerMap = new Map<
    string,
    DataManagerController<any>
  >();

  /** Retorna o controlador do tipo especificado */
  getExistingController(tipo: DataManagerTipoController) {
    const controller = this.dataManagerControllerMap.get(tipo);
    if (controller) {
      return controller;
    }

    throw new Error(
      `DataManagerController para o tipo "${tipo}" não encontrado. Certifique-se de que ele está inicializado antes de usar.`
    );
  }

  /** Gets or creates a DataManagerController for the specified type and provider */
  setupController(
    tipo: DataManagerTipoController,
    provider: DataManagerProvider<any>,
    injector?: Injector
  ) {
    const controller = this.dataManagerControllerMap.get(tipo);
    if (controller) {
      // O controller é singleton por tipo, mas o provider (componente) é recriado a cada navegação
      controller.setProvider(provider);
      return controller;
    }

    const newController = new DataManagerController<any>(
      tipo,
      injector || this.injector,
      provider
    );
    this.dataManagerControllerMap.set(tipo, newController);
    return newController;
  }

  /** Configura o estado de dados alterados do controlador */
  setControllerDadosAlterados(
    tipo: DataManagerTipoController | DataManagerTipoController[],
    dadosAlterados: boolean = true
  ) {
    const tiposLista = Array.isArray(tipo) ? tipo : [tipo];
    tiposLista.forEach((t) => {
      const controller = this.dataManagerControllerMap.get(t);
      if (controller) {
        controller.setDadosAlterados(dadosAlterados);
      }
    });
  }
}
